import React from 'react';
import PaystubList from './../../../components/lists/paystubs';
import PayduesList from '../../../components/lists/paydues';
import { isW2 } from '../../../utilities/jobStatus';

class PayStubsTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { workerId, contractorId, job } = this.props;

        return (
            <div className="worker-documents-tab">
                <div className="section">{isW2(job) ? <PaystubList userId={workerId} /> : <PayduesList contractorId={contractorId} />}</div>
            </div>
        );
    }
}

export default PayStubsTab;



// WEBPACK FOOTER //
// ./src/pages/worker/tabs/paystubs.jsx